export default "__VITE_ASSET__BZYNreoI__"